import { ChangeDetectionStrategy, Component, Input, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription, interval } from 'rxjs';
import { CognitoService } from 'src/app/auth/services/cognito.service';
import { BinanceService } from 'src/app/dashboard/services/binance.service';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import Swal from 'sweetalert2';
import {
  AdminEditPermissionsService,
  TEXTO_SIN_PERMISO_TASAS,
} from 'src/app/shared/services/admin-edit-permissions.service';
import { SetValuesComponent } from '../manual-rate/set-values/set-values.component';
import { WalletCbpayRatesService } from 'src/app/dashboard/services/wallet-cbpay-rates.service';


@Component({
  selector: 'app-cbpay',
  templateUrl: './cbpay.component.html',
  styleUrls: ['./cbpay.component.sass']
})
export class CbpayComponent {
  tasasMin: any = {
    banesco: 0,
    venezuela: 0,
    mercantil: 0,
    provincial: 0,
  };
  tasasMax: any = {
    banesco: 0,
    venezuela: 0,
    mercantil: 0,
    provincial: 0,
  };
  variablesCambio: any;
  timer = interval(60000);
  subscriptions: Subscription = new Subscription();
  email = '';
  tasas: any;
  currentRates: any;
  limiteInferior = '';
  limiteSuperior = '';
  @Input() showCopyToClipboard = false;

  /** Candado de prod (los 4 encargados) para «Actualizar tasas». En QA edita cualquiera. */
  puedeEditar: boolean;
  readonly textoSinPermiso = TEXTO_SIN_PERMISO_TASAS;

  constructor(private spinner: SpinnerService, private binanceService: BinanceService, private auth: CognitoService, private dialog: MatDialog, private cbpayRateService: WalletCbpayRatesService, private permisos: AdminEditPermissionsService) {
    this.puedeEditar = this.permisos.valorInicial;
    this.permisos.puedeEditar().then((puede) => (this.puedeEditar = puede));
    this.initDatos();
  }

  async initDatos() {
    this.getDatosUsuario();
    await this.getCurrentRates();
    this.calcularTasas();
    this.subscriptions.add(
      this.timer.subscribe(() => {
        this.calcularTasas();
      })
    )
    let values = await this.cbpayRateService.getRatesCBPayValuesRates();
  }
  async getCurrentRates() {
    this.currentRates = await this.cbpayRateService.getRatesCBPayValuesRates();
  }

  copyMessageToClipboard() {
    const message = this.generateMessage();
    const listener = (e: ClipboardEvent) => {
      e.clipboardData!.setData('text/plain', message);
      e.preventDefault();
    };
    document.addEventListener('copy', listener);
    document.execCommand('copy');
    document.removeEventListener('copy', listener);
  }

  generateMessage(): string {
    return `ACT🏃🏻🔥🇻🇪
**Minimo 15,000 Bs**
BANESCO \t${this.tasasMax.banesco.toFixed(5)}
PROVINCIAL \t${this.tasasMax.provincial.toFixed(5)}
MERCANTIL\t${this.tasasMax.mercantil.toFixed(5)}
VENEZUELA\t${this.tasasMax.venezuela.toFixed(5)}

**Minimo 10,000 Bs**
BANESCO \t${this.tasasMin.banesco.toFixed(5)}
PROVINCIAL \t${this.tasasMin.provincial.toFixed(5)}
MERCANTIL\t${this.tasasMin.mercantil.toFixed(5)}
VENEZUELA\t${this.tasasMin.venezuela.toFixed(5)}

Favor enviar datos bancarios sin puntos ni guiones

**Disclaimer: al enviar pedido el cliente acepta que su pago puede demorar, no es permitido devolución ni cambio de tasa**`;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  async getDatosUsuario() {
    const cognitoUser = await this.auth.getUser();
    this.email = cognitoUser.attributes['email'];
  }


  async calcularTasas() {
    const valoresCambio =  await this.binanceService.getConversionData();
    this.variablesCambio = valoresCambio;
    this.limiteInferior = this.variablesCambio.limiteInferior;
    this.limiteSuperior = this.variablesCambio.limiteSuperior;

    this.tasasMin.banesco = this.calculoTasaMin();
    this.tasasMin.venezuela = this.calculoTasaMin();
    this.tasasMin.mercantil = this.calculoTasaMin();
    this.tasasMin.provincial = this.calculoTasaMin();

    //TASA MAX
    this.tasasMax.banesco = this.calculoTasaMax();
    this.tasasMax.venezuela = this.calculoTasaMax();
    this.tasasMax.mercantil = this.calculoTasaMax();
    this.tasasMax.provincial = this.calculoTasaMax();
  }

  calculoTasaMax() {
    let clpValor = this.currentRates.data.tasaCLP;
    let valorCompraVES = this.currentRates.data.rate;
    let comision = this.currentRates.data.porcentajeComision;
    const usdt_1 = 10000 / +clpValor;
    const porcentaje_1 = (usdt_1 * comision) / 100;
    const usdt_2 = usdt_1 - porcentaje_1;
    const total_ves = usdt_2 * valorCompraVES;
    return Number((total_ves / 10000).toFixed(5));
  }



  async setRates() {
    const puede = await this.permisos.puedeEditar();
    this.puedeEditar = puede;
    if (this.permisos.bloqueado(puede, TEXTO_SIN_PERMISO_TASAS)) return;
    const data = {
      tasaMercantil: this.currentRates.data.rate,
      tasaVenezuela: this.currentRates.data.rate,
      tasaProvincial: this.currentRates.data.rate,
      tasaBanesco: this.currentRates.data.rate,
      tasaCLP: this.currentRates.data.tasaCLP,
      porcentajeComision: this.currentRates.data.porcentajeComision,
      fuente: 'CBPAY'
    }
    this.dialog.open(SetValuesComponent, { data }).afterClosed().subscribe(res => {
      if (res && res === true) {
        this.getCurrentRates();
        this.calcularTasas();
      }
    })
  }
  calculoTasaMin( ) {
    let clpValor = this.currentRates.data.tasaCLP;
    let valorCompraVES = this.currentRates.data.rate;
    let comision = this.currentRates.data.porcentajeComision;
    let descuento = this.currentRates.data.descuento;
    const usdt_1 = 10000 / +clpValor;
    const porcentaje_1 = (usdt_1 * comision) / 100;
    const usdt_2 = usdt_1 - porcentaje_1;
    const total_ves = usdt_2 * valorCompraVES;
    return Number(((total_ves / 10000) - Number(descuento)).toFixed(5));
  }
}
